 
// http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript

export default function uid (withDashes = true) {
  let currentDateMilliseconds = new Date().getTime()

  const template = withDashes
    ? 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    : 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'

  return template.replace(/[xy]/g, function (currentChar) {
    var randomChar = (currentDateMilliseconds + Math.random() * 16) % 16 | 0

    currentDateMilliseconds = Math.floor(currentDateMilliseconds / 16)

    return (currentChar === 'x' ? randomChar : (randomChar & 0x7) | 0x8).toString(16)
  })
}
